import { createColumnHelper } from '@tanstack/react-table';
import { CheckCircle } from '#assets/ReactSvg.ts';
import { Table } from '../table/Table.tsx';
import styles from './UpsellTable.module.css';

type Feature = {
  featureName: string;
  free: React.ReactNode;
  pro: React.ReactNode;
};

const DATA = [
  { featureName: 'Hosts / Endpoints', free: '100', pro: 'Unlimited' },
  { featureName: 'Routes', free: '2', pro: 'up to 100' },
  {
    featureName: 'Admin & Endpoint SSO',
    free: <CheckCircle className="color-success" />,
    pro: <CheckCircle className="color-success" />,
  },
  { featureName: 'Priority support', free: '-', pro: <CheckCircle className="color-success" /> },
  { featureName: 'Guaranteed uptime', free: '-', pro: <CheckCircle className="color-success" /> },
] satisfies Feature[];

const columnHelper = createColumnHelper<Feature>();
const COLUMNS = [
  columnHelper.accessor('featureName', {
    header: 'Feature',
  }),
  columnHelper.accessor('free', {
    header: 'Free (Current)',
    cell(info) {
      const contents = info.getValue();
      return contents;
    },
    meta: {
      align: 'center',
    },
  }),
  columnHelper.accessor('pro', {
    header: 'Pro',
    cell(info) {
      const contents = info.getValue();
      return contents;
    },
    meta: {
      className: styles.UpsellTable_pro,
      align: 'center',
    },
  }),
];

export function UpsellTable() {
  return <Table className={styles.UpsellTable} rowHeight="short" data={DATA} columns={COLUMNS} />;
}
